<template>
  <div
    v-if="nudges && nudges.length"
    class="copilot-nudges"
  >
    <p class="copilot-nudges__title">
      {{ $t('copilot.suggestedQuestions') }}
    </p>
    <div class="copilot-nudges__list">
      <button
        v-for="nudge in nudges"
        :key="nudge.id || nudge.label"
        type="button"
        class="copilot-nudges__chip"
        @click="$emit('accept', nudge)"
      >
        {{ nudge.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopilotNudges',
  props: {
    /**
     * List of nudges suggested by the backend. Expected minimal shape:
     * - id: string
     * - label: string
     * - prompt?: string (text to send if the nudge is accepted)
     */
    nudges: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../core/assets/scss/colors';

.copilot-nudges {
  margin-bottom: 8px;
}

.copilot-nudges__title {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: $palette-neutral-600;
}

.copilot-nudges__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.copilot-nudges__chip {
  width: 100%;
  text-align: left;
  border-radius: 10px;
  border: 1px solid $palette-neutral-200;
  background-color: $palette-neutral-25;
  padding: 8px 10px;
  font-size: 13px;
  line-height: 1.4;
  color: $palette-neutral-1200;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    background-color: rgba($palette-blue-500, 0.06);
    border-color: rgba($palette-blue-500, 0.35);
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  }
}
</style>
